import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { login } from "../services/authService";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import Loaing from "../icons/loaing";
import { Trans } from "react-i18next";
import {
  EVENT_COLLECT_PROVIDER_KEY,
  EVENT_COLLECT_PROVIDER_VALUE,
  EVENT_COLLECT_TOKEN_KEY,
} from "../utils/constants";

type Inputs = {
  email: string;
  password: string;
};

const schema = yup.object({
  email: yup.string().email().required(),
  password: yup.string().required(),
});

const SignIn = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({ resolver: yupResolver(schema) });
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setLoading(true);
    try {
      const response = await login(data.email, data.password);
      toast.success("login succesfully !");
      if (response.message === "login") {
        navigate("/event-collect");
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error.response && error.response.status === 409) {
        toast.error("email or password is incorrect!");
      }
    }
  };

  const user = localStorage.getItem(EVENT_COLLECT_TOKEN_KEY);
  const provider = localStorage.getItem(EVENT_COLLECT_PROVIDER_KEY);
  if (user && provider === EVENT_COLLECT_PROVIDER_VALUE) {
    return <Navigate to="/event-collect" />;
  }
  return (
    <section className="px-6 md:px-16 font-Poppins">
      <div className="my-[60px]">
        <img
          src="./images/logo-light.png"
          className="w-[160px] h-auto"
          alt="logo"
        />
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 items-center">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="text-[#1E408E] lg:px-24 py-5"
        >
          <h2 className="font-bold text-4xl leading-10">
            <Trans>Welcome to the Quality Portal.</Trans>
          </h2>
          <p className="text-xl mt-10">
            <Trans>Please login to declare an event</Trans>
          </p>

          <span>
            <label htmlFor="email" className="block mt-5 font-Inter">
              <Trans>Enter your ID</Trans>
            </label>
            <input
              type="text"
              {...register("email")}
              className="block h-10 md:w-[20rem] w-full border border-[#1E408E] bg-[#DFDFDF4D] px-2 rounded focus:border-[#1E408E] mt-[10px]"
            />
            {errors["email"] && (
              <p className="text-red-500 text-xs">{errors["email"]?.message}</p>
            )}
          </span>
          <div>
            <label htmlFor="password" className="block mt-5 font-Inter">
              <Trans>Password</Trans>
            </label>
            <input
              type="password"
              {...register("password")}
              name="password"
              className="block h-10 md:w-[20rem] w-full border border-[#1E408E] bg-[#DFDFDF4D] px-2 rounded focus:border-[#1E408E] mt-[10px]"
            />
            {errors["password"] && (
              <p className="text-red-500 text-xs">
                {errors["password"]?.message}
              </p>
            )}
          </div>
          <div className="flex flex-wrap justify-between">
            <button className="bg-[#1E408E] text-white mt-10 py-2 px-5 rounded-3xl">
              <Trans>Login</Trans>
            </button>
            {loading && (
              <div className="mt-10">
                <Loaing />
              </div>
            )}
          </div>
        </form>
        <div className="hidden lg:grid justify-center">
          <img
            src="/images/LoginPage.png"
            alt="babies"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default SignIn;
